import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan } from "./Style";
import { useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";


import {useLocation,useSearchParams} from 'react-router-dom';

const Success = (props) => {

  const {location} = useLocation();
  const [queryParameters] = useSearchParams();
  const { instance } = useMsal();



  return (
  
      <div>
        <HeaderContainer>
          <Typography sx={{ flexGrow: 1 }}>
            <HeaderText><Typography variant="h6">Success</Typography></HeaderText>
          </Typography>
        </HeaderContainer>
        <InputContainer>
          <InputWrapper>
          <Typography sx={{ flexGrow: 1 }}>
           <Typography variant="h6">{queryParameters.get("message")}</Typography>
          </Typography>
          </InputWrapper>


        </InputContainer>
      </div>

  
  );
};
export default Success;
